import { observable, action, computed, toJS, makeObservable } from 'mobx'
import Stores from '.'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from './asideModalStore'
import { dict } from '../Localisation'
import { timeConverter2 } from '../components/ContentBox/Online-schedule/components/functions'

class UsersStore {
  infoProfile = []
  userDocs = []
  userCerts = []
  userContractsData = []
  userSalaryData = []
  isError = false

  constructor() {
    makeObservable(this, {
      infoProfile: observable,
      userDocs: observable,
      userContractsData: observable,
      userCerts: observable,
      userSalaryData: observable,

      getProfileData: action,
      updateProfile: action,
      setUserDocs: action,
      addUserDoc: action,
      setUserCerts: action,
      addCert: action,
      deleteUserCert: action,
      setUserContracts: action,
      addUserContract: action,
      createContract: action,
      setUserSalary: action,

      userDocslist: computed,
      userContracts: computed,
      userSalary: computed,
      userCertObject: computed,
      userProfile: computed,
    })
  }

  addCert = (row) => {
    let Data = Stores.observableArray(this.userCerts)
    Data.push(row)
    this.userCerts = Data
  }

  createContract = (translate, user) => {
    const contract = {
      name: 'employee_contract',
      link: 'employees/contract',
      button: translate(dict.main_page.add),
      title: translate(dict.contract.adding_contract),
      type: 'employee_contract',
      data: 'json',
      profile: user.profile.id,
      isResponsive: true,
      onSubmitSuccess: (data) => this.addUserContract(data),
      valid: {
        title: 'required',
      },
    }
    const initStateContract = {
      date_from: timeConverter2(new Date()),
      date_until: timeConverter2(new Date().getFullYear() + '-12-31'),
      employee_id: user.profile.id,
    }
    asideModalStore.activity(contract, initStateContract)
  }

  addUserContract = (data) => {
    this.userContractsData = [...this.userContractsData, data]
  }

  get userCertObject() {
    return Stores.observableArray(this.userCerts)
  }

  setUserSalary = (data) => {
    this.userSalaryData = data
  }

  setUserCerts = (id) => {
    superAxiosRequest({
      method: 'get',
      link: 'groups/get_student_certs',
      params: { student: id },
    }).then((res) => (this.userCerts = res.data.result || []))
  }

  deleteUserCert = (id) => {
    let Data = Stores.observableArray(this.userCerts)
    Data = Data.filter((x) => x.id !== id)
    this.userCerts = Data
  }

  getProfileData = (id) => {
    superAxiosRequest({
      method: 'get',
      link: 'accounts/employers_detail/' + id,
    })
      .then((res) => {
        this.infoProfile = res.data
      })
      .catch((error) => {
        if (error) this.isError = true
      })
  }

  updateProfile = (data) => {
    this.infoProfile = data
  }

  deleteProfile = () => {
    this.infoProfile = []
  }

  get userDocslist() {
    return toJS(this.userDocs)
  }

  setUserDocs = (id) => {
    const conf = {
      link: 'employees/appendix',
      method: 'get',
      params: {
        employee_id: id,
      },
    }
    superAxiosRequest(conf).then((res) => (this.userDocs = res.data.result))
  }

  addUserDoc = (data) => {
    this.userDocs = this.userDocs.map((doc) =>
      doc.id === data.id ? data : doc,
    )
  }

  setUserContracts = (id) => {
    superAxiosRequest({
      link: 'employees/contract',
      method: 'get',
      params: {
        employee: id,
        limit: 999,
      },
    })
      .then(({ data }) => {
        this.userContractsData = data.result
      })
      .catch(() => {
        this.userContractsData = []
      })
  }

  get userProfile() {
    return toJS(this.infoProfile)
  }

  get userSalary() {
    return toJS(this.userSalaryData)
  }

  get userContracts() {
    return toJS(this.userContractsData)
  }
}

export default UsersStore = new UsersStore()
